module.exports = __webpack_public_path__ + "static/media/bastings-map-v2.be4236c4.png";